import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { handleAxiosErrorMessage } from '../../../utils';
import { setMessage } from '../../toasts/toastSlice';
import { NOTIFICATION_TYPES } from '../../../config/consts/commons';

export default function useOnErrorHandler({ query, onError }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (query.isError) {
      const errorMessage = handleAxiosErrorMessage(query.error);
      dispatch(
        setMessage({
          body: errorMessage,
          type: NOTIFICATION_TYPES.ERROR,
        })
      );
      if (onError) {
        onError(query.error);
      }
    }
  }, [query.isError, query.error, onError, dispatch]);
}
